class OnedioError extends Error {
  constructor(err, statusCode) {
    super(err);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, OnedioError);
    }
    this.name = 'OnedioError';
    // Custom debugging information
    this.statusCode = statusCode;
  }
}
export default ({ res, $sentry }, inject) => {
  inject('error', (err, status, sendLogToSentry = true) => {
    const statusCode = status || err.statusCode || err.status || (err.response && err.response.status) || 500;
    if (process.server) {
      res.statusCode = statusCode;
    }
    if (sendLogToSentry && err.name !== 'OnedioError') {
      $sentry.captureException(err);
    }
    throw new OnedioError(err, statusCode);
  });
};
